export class InsurancePaymentOverpayListModel {
  PatientID: string;
  PaymentID: string;
  ClaimItemID: string;
  ClaimNumber: number;
  PatientName: string;
  Amount: number;
  LOCID: number;
}
